import React from "react";
import { Typography, Tooltip } from "antd";
import { DEPOSIT_STATUS, Transaction, WITHDRAW_STATUS } from "./type";
import Icon from "../../components/Icon/Icon";
import { Pill, PillStyle, SOLID } from "src/components";
import colors from 'src/theme/colors.json';

export const TransactionStatus: React.FunctionComponent<Transaction> = (props) => {
  if (props.editingBy) {
    return (
      <Typography.Text>
        {props.statusMessage}
      </Typography.Text>
    )
  }
  const getTextColor = () => {
    if ([DEPOSIT_STATUS.COMPLETED, DEPOSIT_STATUS.TRANSFER_BACK, WITHDRAW_STATUS.COMPLETED].some(_s => _s === props.status)) return 'success';
    if ([WITHDRAW_STATUS.REJECTED, DEPOSIT_STATUS.CANCELLED].some(_s => _s === props.status)) return 'danger';
    return 'warning';
  }
  return (
    <Typography.Text type={getTextColor()}>
      {props.status !== WITHDRAW_STATUS.UNCONFIRM && props.statusMessage}
      {props.status === WITHDRAW_STATUS.UNCONFIRM && (
        <Tooltip trigger={['hover']} title={(
          <>
            ธนาคารล่ม
            <br />
            กรุณาเช็คจากแอปธนาคาร
          </>
        )}>
          <span>
            <Icon name="outline-check-1" />
          </span>
          &nbsp;
          {props.statusMessage}
        </Tooltip>
      )}
    </Typography.Text>
  )
};

export const Remark: React.FC<Transaction> = (props) => {
  const { adjustType, remark } = props;

  const withBaseStyle = (pillStyle: PillStyle): PillStyle => {
    return {
      wrapper: {
        ...pillStyle.wrapper,
        width: 120,
      },
      left: {
        ...pillStyle.left,
        color: '#FFF',
      },
      right: {
        ...pillStyle.right,
        color: '#FFF',
      },
    }
  }
  switch (adjustType) {
    case 'WRONG_SLIP_VOIDABLE':
      return (
        <>
          {remark}
          <Pill
            customStyles={withBaseStyle(SOLID({ backgroundLeft: colors["@green-6"], backgroundRight: colors["@volcano-6"], }))}
            left={(<>ตัดได้</>)}
            right={(<>ผิดสลิป</>)}
          />
        </>
      )
    case 'WRONG_SLIP_UNVOIDABLE':
      return (
        <>
          {remark}
          <Pill
            customStyles={withBaseStyle(SOLID({ backgroundLeft: colors["@cloud-6"], backgroundRight: colors["@volcano-6"] }))}
            left={(<>ตัดไม่ได้</>)}
            right={(<>ผิดสลิป</>)}
          />
        </>
      )
    case 'WRONG_USER_VOIDABLE':
      return (
        <>
          {remark}
          <Pill
            customStyles={withBaseStyle(SOLID({ backgroundLeft: colors["@green-6"], backgroundRight: colors["@yellow-6"] }))}
            left={(<>ตัดได้</>)}
            right={(<>ผิดยูส</>)}
          />
        </>
      )
    case 'WRONG_USER_UNVOIDABLE':
      return (
        <>
          {remark}
          <Pill
            customStyles={withBaseStyle(SOLID({ backgroundLeft: colors["@cloud-6"], backgroundRight: colors["@yellow-6"] }))}
            left={(<>ตัดไม่ได้</>)}
            right={(<>ผิดยูส</>)}
          />
        </>
      )
    default:
      return <>{remark}</>
  }
}
